module.exports = __webpack_public_path__ + "media/images/iconSocialLink__errorRed--dark-c3bb2803679982443ff2d60b37b241a4.png";